import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MyTimelineEvent} from '../../models/myTimelineEvent.model';
import {Category} from '../../models/category.model';
import {Question} from '../../models/question.model';
import {PrinceStage} from '../../models/princeStage.model';
import {QuestionResponse} from '../../models/response.model';
import {PrinceStageService} from '../../services/prince.service';
import {CategoryService} from '../../services/category.service';
import {QuestionService} from '../../services/question.service';
import {ResponseService} from '../../services/response.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {QuestionResponseHistory} from '../../models/questionResponse.model';
import {StatusService} from '../../services/status.service';
import {Status} from '../../models/status.model';
import {Project} from '../../models/project.model';
import {ProjectService} from '../../services/project.service';
import {SessionService} from '../../services/session.service';
import {ResponseOption} from '../../models/responseOption.model';
import {ResponseOptionService} from '../../services/responseOption.service';
import {isNullOrUndefined} from 'util';
import {any} from 'codelyzer/util/function';


@Component({
  selector: 'app-project-wizard',
  templateUrl: './project-wizard.component.html',
  styleUrls: ['./project-wizard.component.css']
})
export class ProjectWizardComponent implements OnInit {
  paramClient = '';
  paramProject = '';
  princeStageList: PrinceStage[] = [];
  categoryList: Category[] = [];
  questionList: Question[] = [];
  responseList: QuestionResponse[] = [];
  statusList: Status[] = [];
  responseOptionList: ResponseOption[] = [];
  questionResponseHistoryList: QuestionResponseHistory[] = [];
  editedResponses = {};
  selectedProject: Project;
  allowSave = false;
  editingState = false;
  myIsNullOrUndefined = isNullOrUndefined
  temp= any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private toastr: ToastrService, private princeService: PrinceStageService, private categoryService: CategoryService, private questionService: QuestionService, private responseService: ResponseService, private statusService: StatusService, private projectService: ProjectService, private responseOptionService: ResponseOptionService) {
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      if (params.hasOwnProperty('client') && params.hasOwnProperty('project')) {
        this.paramClient = params['client'];
        this.paramProject = params['project'];
      } else {
        this.router.navigate(['invalidClientProject']);
      }
    });
    this.getPrinceStages();
    this.getProjects();
    if (SessionService.user) {
      this.editingState = SessionService.user.is_superuser;
    }
  }

  getProjects() {
    if (SessionService.selectedProject) {
      this.selectedProject = SessionService.selectedProject;
    } else {
      this.projectService.getAllProjects().subscribe((projectList) => {
        this.selectedProject = projectList.filter(value => {
          return value.Client === this.paramClient && value.Project === this.paramProject;
        })[0];
        if (!this.selectedProject) {
          this.router.navigate(['/project-not-found/' + this.router.url]);
        }
      }, (err: HttpErrorResponse) => {
        console.log('Error :' + JSON.stringify(err));
        setTimeout(() => this.toastr.error('' + err.message, err.statusText + ' in AllProject Retrieval : Code ' + err.status));
      });
    }
  }

  getPrinceStages() {
    this.princeService.getPrinceStages().subscribe(princeStages => {
      this.princeStageList = princeStages.sort((a, b) => {
        return a.DisplayOrder - b.DisplayOrder;
      });
      this.getCategories();
    }, (err: HttpErrorResponse) => {
      console.log('Error :' + JSON.stringify(err));
      setTimeout(() => this.toastr.error('' + err.message, err.statusText + ' in AllProject Retrieval : Code ' + err.status));
    });
  }

  getCategories() {
    this.categoryService.getCategories().subscribe(categories => {
      this.categoryList = categories.sort((a, b) => {
        return a.DisplayOrder - b.DisplayOrder;
      });
      this.getQuestions();
    }, (err: HttpErrorResponse) => {
      console.log('Error :' + JSON.stringify(err));
      setTimeout(() => this.toastr.error('' + err.message, err.statusText + ' in AllProject Retrieval : Code ' + err.status));
    });
  }

  getQuestions() {
    this.questionService.getQuestions().subscribe(questions => {
      this.questionList = questions.sort((a, b) => {
        return a.DisplayOrder - b.DisplayOrder;
      });
      this.getResponses();
    }, (err: HttpErrorResponse) => {
      console.log('Error :' + JSON.stringify(err));
      setTimeout(() => this.toastr.error('' + err.message, err.statusText + ' in AllProject Retrieval : Code ' + err.status));
    });
  }

  getResponses() {
    this.responseService.getResponses(this.paramClient, this.paramProject).subscribe(responses => {
      this.responseList = responses;
      this.getStatuses();
    }, (err: HttpErrorResponse) => {
      console.log('Error :' + JSON.stringify(err));
      setTimeout(() => this.toastr.error('' + err.message, err.statusText + ' in AllProject Retrieval : Code ' + err.status));
    });
  }

  getStatuses() {
    this.statusService.getStatuses().subscribe(stats => {
      this.statusList = stats.sort((a, b) => {
        return a.DisplayOrder - b.DisplayOrder;
      });
      this.getResponseOptions();
    });
  }

  getResponseOptions() {
    this.responseOptionService.getResponseOptions().subscribe(values => {
      this.responseOptionList = values.sort((a, b) => {
        return a.DisplayOrder - b.DisplayOrder;
      });
      this.prepareQuestionResponseHistory();
    });
  }

  getStatusbyId(id: number) {
    return this.statusList.filter(stat => {
      // console.log(this.statusList);
      return stat.id === id;
    });
  }


  getResponseOptionbyId(id: number) {
    return this.responseOptionList.filter(opt => {
      return opt.id === id;
    });
  }

  questionResponseEdited(obj: QuestionResponseHistory) {
    this.allowSave = true;
    this.editedResponses[obj.question.id] = obj;
  }

  saveChanges() {
    let validResponse = 0;
    for (const res in this.editedResponses) {
      validResponse = this.editedResponses[res].latestResponse.Value;
    }
    console.log(validResponse + 1);
    if (validResponse.toString() === '5') {
      setTimeout(() => this.toastr.error('Please select valid response', ' Invalid Response '));
    } else {
      const toBeSaved = [];
      for (const res in this.editedResponses) {
        console.log(this.editedResponses);
        this.editedResponses[res].latestResponse.Client = this.selectedProject.Client;
        this.editedResponses[res].latestResponse.Project = this.selectedProject.Project;
        this.editedResponses[res].latestResponse.QuestionId = this.editedResponses[res].question.id;
        this.editedResponses[res].latestResponse.isSuperUserEntry = this.editingState;
        if (this.editedResponses[res].latestResponse.Comment === '') {
          this.editedResponses[res].latestResponse.Comment = '...';
        }
        if (!this.editingState) {
          this.editedResponses[res].latestResponse.StatusId = this.statusList.filter(value => {
            return value.Name === 'Review Pending';
          })[0].id;
        }
        toBeSaved.push(this.editedResponses[res].latestResponse);
        console.log(this.editedResponses[res].latestResponse);

      }
      this.responseService.saveResponses(toBeSaved).subscribe(response => {
        this.editedResponses = {};
        this.getResponses();
        setTimeout(() => this.toastr.success('Change(s) saved.', 'Success!!!'));
        // this.snackBarService.showSnackBar('Please enter valid mileage', 'close', 'failure');
      }, (err: HttpErrorResponse) => {
        console.log('Error :' + JSON.stringify(err));
        setTimeout(() => this.toastr.error('' + err.message, err.statusText + ' in saving Response : Code ' + err.status));
      });
    }
  }

  prepareQuestionResponseHistory() {
    this.questionResponseHistoryList = [];
    for (const question of this.questionList) {
      const responses = this.responseList.filter(res => {
        return res.QuestionId === question.id;
      }).sort((a, b) => {
        if (a.EntryDate > b.EntryDate) {
          return -1;
        }
        if (a.EntryDate === b.EntryDate) {
          return 0;
        }
        return 1;
      });
      const histories = new Array<MyTimelineEvent>();

      if (responses.length > 0) {
        for (const histry of responses) {
          histories.push({
            date: histry.EntryDate,
            header: '',
            body: '',
            icon: 'fa-pencil-square',
            response: histry
          });
        }
        const latestResponse = Object.assign({}, responses[0]);
        latestResponse.Comment = '';
        this.questionResponseHistoryList.push({
          question: question,
          latestResponse: latestResponse,
          history: histories
        });
      } else {
        this.questionResponseHistoryList.push({
          question: question,
          latestResponse: new QuestionResponse(),
          history: histories
        });
      }
    }
  }

  goHome() {
    this.router.navigate(['/root/dashboard']);
  }

}




// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/components/project-wizard/project-wizard.component.ts